import type { DemoSection, DemoResult } from "@/types/demo";

export function calcResult(
  sections: DemoSection[],
  answers: Record<string, string>,
): DemoResult {
  const totalQuestions = sections.reduce((s, sec) => s + sec.questions.length, 0);
  const resultSections = sections.map((sec) => {
    let correct = 0,
      wrong = 0,
      unanswered = 0;
    for (const q of sec.questions) {
      const a = answers[q.id];
      if (!a) {
        unanswered++;
        continue;
      }
      const opt = q.options.find((o) => o.key === a);
      if (opt?.isCorrect) correct++;
      else wrong++;
    }
    const score =
      sec.questions.length > 0 ? Math.round((correct / sec.questions.length) * 100) : 0;
    return {
      title: sec.title,
      correct,
      wrong,
      unanswered,
      score,
      isPassed: score >= sec.passingGrade,
      total: sec.questions.length,
    };
  });
  const totalCorrect = resultSections.reduce((s, sec) => s + sec.correct, 0);
  const totalWrong = resultSections.reduce((s, sec) => s + sec.wrong, 0);
  const totalUnanswered = resultSections.reduce((s, sec) => s + sec.unanswered, 0);
  const totalScore =
    totalQuestions > 0 ? Math.round((totalCorrect / totalQuestions) * 100) : 0;
  const isPassed = resultSections.every((s) => s.isPassed);
  return {
    sections: resultSections,
    totalCorrect,
    totalWrong,
    totalUnanswered,
    totalScore,
    isPassed,
  };
}

export const pad = (n: number) => String(n).padStart(2, "0");

export const fmtTime = (s: number) =>
  `${pad(Math.floor(s / 60))}:${pad(Math.max(s % 60, 0))}`;
